import type { EnhancedDeal, TimberProject } from '../types';

/**
 * Ascending sort key: project number from deal (e.g. 26-014), then name.
 * Matches sidebar / internal docs order (#0017 before #0050).
 */
export function projectSortKey(p: TimberProject, deal: EnhancedDeal | undefined): string {
  const raw = (deal?.projectNumber || '').trim().replace(/^#/, '');
  if (raw) {
    return `0:${raw.padStart(8, '0')}`;
  }
  return `1:${(p.name || '').toLowerCase()}`;
}

export function compareTimberProjectsByDealMap(
  a: TimberProject,
  b: TimberProject,
  dealsById: Map<string, EnhancedDeal>,
): number {
  const da = a.dealId ? dealsById.get(a.dealId) : undefined;
  const db = b.dealId ? dealsById.get(b.dealId) : undefined;
  return projectSortKey(a, da).localeCompare(projectSortKey(b, db));
}
